import { render, staticRenderFns } from "./EpicentralDetail.vue?vue&type=template&id=6bc50114&scoped=true"
import script from "./EpicentralDetail.vue?vue&type=script&lang=js"
export * from "./EpicentralDetail.vue?vue&type=script&lang=js"
import style0 from "./EpicentralDetail.vue?vue&type=style&index=0&id=6bc50114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc50114",
  null
  
)

export default component.exports